exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#center {\n  -ms-flex-line-pack: center;\n      align-content: center; \n  text-align: center;\n}\n\n.center {\n  -ms-flex-line-pack: center;\n      align-content: center; \n  text-align: center;\n}\n\n.smallSize {\n  max-width: 7vw;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/review/review.component.css
// module id = ../../../../../src/app/review/review.component.css
// module chunks = main